import React from 'react';
import ReactDOM from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import App from './App';
import './index.css';
import './styles/global.css';
import reportWebVitals from './reportWebVitals';
import { API_CONFIG } from './config/apiRouting';

// Configure Amplify
const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || 'us-east-1_Jw9kHxDre',
      userPoolClientId: process.env.REACT_APP_COGNITO_CLIENT_ID || '2sjuuubp9b9332tc6rf4p3t1fe',
      region: process.env.REACT_APP_AWS_REGION || 'us-east-1',
      identityPoolId: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID,
      loginWith: {
        email: true,
      },
      signUpVerificationMethod: 'code' as const,
      userAttributes: {
        email: {
          required: true,
        },
        name: {
          required: true,
        },
      },
      allowGuestAccess: false,
      passwordFormat: {
        minLength: 8,
        requireLowercase: true,
        requireUppercase: true,
        requireNumbers: true,
        requireSpecialCharacters: true,
      },
    },
  },
  API: {
    REST: {
      restaurantApi: {
        endpoint: process.env.REACT_APP_API_URL || API_CONFIG.microservices.coreData.url,
        region: process.env.REACT_APP_AWS_REGION || 'us-east-1',
      },
    },
  },
};

Amplify.configure(amplifyConfig as any);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();